// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Halogen_Aff_Util from "../Halogen.Aff.Util/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
import * as Visonum_BulkPingApp_Components_App from "../Visonum.BulkPingApp.Components.App/index.js";
import * as Visonum_BulkPingApp_StaticConfig from "../Visonum.BulkPingApp.StaticConfig/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var map = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var liftEither = /* #__PURE__ */ Control_Monad_Error_Class.liftEither(Effect_Aff.monadThrowAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var main = /* #__PURE__ */ Halogen_Aff_Util.runHalogenAff(/* #__PURE__ */ bind(Halogen_Aff_Util.awaitBody)(function (body) {
    return bind(bind(map(lmap(Effect_Exception.error))(liftEffect(Visonum_BulkPingApp_StaticConfig.getStaticConfig)))(liftEither))(function (staticConfig) {
        return bind(Halogen_VDom_Driver.runUI(Visonum_BulkPingApp_Components_App.component)({
            staticConfig: staticConfig
        })(body))(function () {
            return pure(Data_Unit.unit);
        });
    });
}));
export {
    main
};
//# sourceMappingURL=index.js.map
